<template>
    <div id="app">
        <!-- <section class="nav m_header" >
            <div :class="index==0?'current':''" v-for="item,index in header">
                <a :href="item.url">
                    {{item.typename}}
                    <p>{{item.description}}</p>
                </a>
            </div>
           
        </section> -->
        <div class="header">
            <div class="container">
                <div class="logo"></div>
                <ul class="main_nav">
                    <li :class="index==0?'current':''" v-for="item,index in header">
                        <a :href="item.url">{{item.typename}}<span>{{item.description}}</span></a>
                    </li>
                </ul>
                <a class="user_center" @click="linkTo">个人中心</a>
            </div>

        </div>
        <router-view></router-view>
        <div class="footer">
            <div class="container">
                <div class="left_foot">
                    <p class="address">青岛市市南区延安三路105号<br />市南区民生大厦5层</p>
                    <p class="tel">0532-6889 6608</p>
                    <a href="">
                        <p class="email">意见反馈</p>
                    </a>
                </div>
                <div class="right_foot">
                    <p>青岛市市南区文化馆 QINGDAO SHINAN CULTARAL CENTER</p>
                    <p>技术支持：青岛智慧同城信息科技有限公司</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                header: []
            }
        },
        provide() {
            return {
                ajax: this.ajax
            }
        },
        mounted() {
            this.ajax('/api/index/index', 'get', '', res => {
                this.header = res.data.data
            })
        },
        methods: {
            linkTo() {
                if (this.$route.path != '/account') {
                    this.$router.push('/account')
                }
            },
            ajax(url, method, params, callback, errback) {
                this.$loading.show()
                this.axios({
                    method: method,
                    url: url,
                    data: params,
                    params:params
                }).then(res => {
                    this.$loading.hide()
                    if (res.data.errcode == 0) {
                        callback(res)
                    } else if (res.data.errcode == "login") {
                        if (this.$route.path != "/login") {
                            this.$router.push({
                                path: '/login',
                                query: {
                                    login: 'login'
                                }
                            })
                        }
                    } else {
                        if (typeof errback === "function") {
                            errback(res)
                        }
                        this.$toast(res.data.errmsg)
                    }
                })
            }
        }
    }
</script>
<style>
    .m_header{
        display: none;
        position: fixed;
        width: 100vw;
        top: 0;
        left: 0;
        background: #fff;
        z-index: 999999;
    }
    
    #app {

        min-height: 100vh;
        padding: 154px 0;
        background: #f2f2f2;
    }

    .container {
        width: 1200px;
        margin: 0 auto;
        position: relative;
    }

    .formbox {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: #fff;
        right: 40px;
        width: 496px;
        padding: 35px 53px;
        border-radius: 7px;
    }

    .boxShadow {
        box-shadow: 0 10px 10px #ececec;
    }

    ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: #a3a3a3;
    }

    ::-moz-placeholder {
        /* Firefox 19+ */
        color: #a3a3a3;
    }

    :-ms-input-placeholder {
        /* IE 10+ */
        color: #a3a3a3;
    }

    :-moz-placeholder {
        /* Firefox 18- */
        color: #a3a3a3;
    }

    .form_title {
        font-size: 1.2em;
        text-align: center;
        color: #20a7fa;
        position: relative;
        padding: 15px 0;
        padding-top: 0;
    }

    .form_footer {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        padding: 0 3px;
        font-size: 0.85rem;
        color: #20a7fa;
        cursor: default;
    }

    .form_footer span:first-child {
        color: #5e5e5e;
    }

    .btn {
        width: 150px;
        line-height: 2.5em;
        text-align: center;
        font-size: 0.9em;
        margin: 0 auto;
        border-radius: 7px;
        cursor: pointer;
        position: relative;
    }

    .btn-primary {
        background: #4ba6ff;
        color: #fff;
    }

    .btn-primary:hover {
        opacity: 0.8;
    }

    .btn-default {
        background: #eeeeee;
        color: #666666;
        border: 1px solid #dcdcdc;
    }

    .right {
        width: calc(100% - 20px - 200px);
        padding: 40px;
        background: #fff;
    }

    .right>h5 {
        font-size: 1.3em;
        color: #333333;
        text-align: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
    }

    .userCenter {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 12%;
        color: #0758a4;
        font-size: 0.9em;
        font-weight: bold;
        cursor: pointer;
    }

    .header .user_center {
        position: absolute;
        right: -30px;
        top: 0;
        padding-left: 20px;
        height: 36px;
        line-height: 40px;
        color: #888;
        background: url(assets/user_center.png) no-repeat left center;
        background-size: auto 16px;
        cursor: pointer;
    }

    .nav {
        align-items: center;
        flex-wrap: wrap;
    }

    .nav>div {
        position: relative;
        width: 25%;
        text-align: center;
        padding: 0.1rem 0;
        border-bottom: 2px solid #98bdf8;
    }

    .nav>div>a {
        display: block;
        height: 0.48rem;
        padding-top: 5px;
        font-size: 0.12rem;
        font-weight: 800;
        color: #0758a4;
        line-height: 1;
        border-right: 1px solid #a3c3c8;
    }

    .nav>div:nth-child(4n) a {
        border-right: none;
    }

    .nav>div>a>p {
        display: block;
        font-size: 12px;
        color: #999;
        font-weight: normal;
        margin-top: 0.05rem;
    }

    .nav .current,
    .nav>div:hover {
        background: url(../public/images/nav_bg.png) no-repeat;
    }

    .nav .current a,
    .nav .current a>p,
    .nav>div:hover>a,
    .nav>div:hover>a>p {
        color: #fff;
        border: none;
    }

    .nav>div ul {
        width: 100%;
        display: none;
        position: absolute;
        top: calc(100% + 2px);
        z-index: 999;
        opacity: 0.85;
        background: #fff;
    }

    .nav>div ul>li {
        height: 0.5rem;
        font-size: 0.12rem;
        border-bottom: 1px solid #cfe0fc;
        color: #666666;
        text-align: center;
        padding: 0.05rem;
    }

    .nav>div ul>li p {
        line-height: 1;
        transform: scale(0.9);
    }

    .nav>div:hover ul {
        display: block;
    }
    .user_center{display: none}
    @media only screen and (max-width: 750px) {
        .m_header{
            display: flex;
        }
        #app{padding: .5rem 0 1rem;}
        .header{display: none;}
        .formbox{padding: 0.2rem;}
        .form_tabbar{font-size: 0.15rem!important;}
        .container{width: 92%!important;min-height: auto!important;margin: 0 4%;}
        .footer{display: none;}
        .right{width: 100%;padding: 0.2rem;}
        .left{position: fixed;top: 0;left: 0;width: 100%!important;height: 0.36rem;border: 1px solid #eee;background: #fff;z-index: 99999; }
        /* .left::before{
            display: block;
            content: '';
            width: 0.34rem;
            height: 0.34rem;
            background-image: url(../public/images/menu.png);
            background-size: 100% 100%;
            
        } */
        .user_center{
            display: block;
            position: fixed;
            bottom: 0px;
            width: 100%;
            height: 0.4rem;
            color: #fff;
            background: #4ba6ff;
            line-height: 0.4rem;
            font-size: 0.15rem;
            left: 0;
            text-align: center;
        }
        .userBox .menu li:nth-child(4){
            display: none;
        }
    }
</style>